import { Directive, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl, NgControl, Validators } from "@angular/forms";

@Directive()
export abstract class InputWrapperComponent<T> implements OnInit, ControlValueAccessor {
  get required(): boolean {
    return this.formControl?.hasValidator(Validators.required);
  }
  @Input() label: string = '';
  @Input() isDisabled = false;
  @Input() infoText: string;
  @Input() bgColorClass = 'bg-sun-yellow';
  @Input() infoIconColorClass = 'text-color-blue2';

  infoIconSize = 21;
  formControl: FormControl;
  value: T;
  requiredClasses = "after:content-['*'] after:text-red-700";
  inputNoPaddingClasses = 'rounded-[4px] border placeholder:font-bold w-full placeholder-pscblack-20-opacity transition ease-in-out duration-200 border-[#0D152933] flex-1';
  inputClasses = `${ this.inputNoPaddingClasses } pl-[16px] pb-[16px] pt-[16px]`;
  labelClasses = 'mb-1 block font-medium';

  constructor(
    public ngControl: NgControl,
  ) {
    ngControl.valueAccessor = this;
  }
  // eslint-disable-next-line @angular-eslint/contextual-lifecycle
  ngOnInit(): void {
    // syncing with validators on host element
    this.formControl = this.ngControl?.control as FormControl;
  }
  onChange: any = () => {
  };
  onTouch: any = () => {
  };

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  writeValue(value: T): void {
    this.value = value;
    this.onChange(value);
  }

  onModelChange(value: T) {
    this.value = value;
    this.onChange(this.value);
  }
}
